import React, { useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import FormLabel from '../FormLabel'

const modules = {
  toolbar: [
    // [{ header: '1' }, { header: '2' }],
    ['bold', 'italic', 'underline', 'strike'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      // { indent: '-1' },
      // { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
}

const formats = [
  'header',
  'font',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
]

const TextEditor = ({label, onChange, value}) => {
  return (
    <div className="flex flex-col space-y-1">
      <FormLabel label={label}/>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={'Answer'}
        style={{backgroundColor:"white"}}
      />
    </div>
  )
}

export default TextEditor
